/**
 * There will be one saga file per component
 */
import { takeEvery, debounce, fork, all } from 'redux-saga/effects';
import {
    GET_AUTH_TOKEN,
    GET_HYBRIS_USER_DETAILS,
    LOGIN,
    SET_LOGOUT,
    GET_BANNER_DETAILS,
    GET_CONFIGURATION,
    GET_QR_CODE_REQUEST,
    GET_BATCH_EXPORT_REQUEST,
} from '../actions/constants';
import getAuthToken from './authToken';
import { getHybrisUserDetails, logout } from './hybrisUserDetails';
import { loginSaga } from './login';
import { getBannerDetails } from './hybrisBannerDetails';
import { getConfigurations } from './getConfigurations';
import {getQRCodeSaga} from './qrCodeSaga';
import {batchExportSaga} from './batchExportSaga';

function* watchGetAuthToken() {
    yield takeEvery(GET_AUTH_TOKEN, getAuthToken);
}

function* watchGetHybrisUserDetails() {
    yield takeEvery(GET_HYBRIS_USER_DETAILS, getHybrisUserDetails);
}

function* watchGetConfigurations() {
    yield takeEvery(GET_CONFIGURATION, getConfigurations);
}

function* watchLogout() {
    yield debounce(100, SET_LOGOUT, logout);
}

function* watchGetBannerDetails() {
    yield takeEvery(GET_BANNER_DETAILS, getBannerDetails);
}
function* watchQrCode() {
    yield takeEvery(GET_QR_CODE_REQUEST, getQRCodeSaga);
}

function* watchBatchExport() {
    yield takeEvery(GET_BATCH_EXPORT_REQUEST, batchExportSaga);
}

function* watchLogin() {
    yield takeEvery(LOGIN, loginSaga);
}

export default function* CommonsSaga() {
    yield all([
        fork(watchGetAuthToken),
        fork(watchGetHybrisUserDetails),
        fork(watchLogin),
        fork(watchLogout),
        fork(watchGetBannerDetails),
        fork(watchGetConfigurations),
        fork(watchQrCode),
        fork(watchBatchExport),
    ]);
}
